export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4651.4b7d845a.jpg";